/**
 * Created by litao on 2018/10/25.
 */
export default function (redirect) {

    const load = require('./import/_import_' + process.env.NODE_ENV);

    return {
        other: [
            {
                name: 'login',
                path: '/login',
                component: load('views/login/index'),
                meta: {permissionCode: '*'}
            },
            {
                name: 'oauth',
                path: '/oauth',
                component: load('views/index/oauth'),
                meta: {permissionCode: '*'}
            },
            {
                name: 'oauthLogin',
                path: '/oauthLogin',
                component: load('views/index/oauthLogin'),
                meta: {permissionCode: '*'}
            },

            {
                name: 'loginNew',
                path: '/loginNew',
                component: load('views/login/indexNew'),
                meta: {permissionCode: '*'}
            },
            {
                name: 'prelogin',
                path: '/prelogin',
                component: load('views/index/index1'),
                meta: {permissionCode: '*'}
            },
            {
                name: 'error',
                path: '/error/:errorPageRoute?',
                props: true,
                component: load('views/error/index'),
                meta: {permissionCode: '*'}
            },


        ],
        permission: [
            {
                name: '/',
                path: '/',
                component: load('views/layout/index'),
                redirect,
                children: [
                    {
                        name: 'enroll',
                        path: 'enroll',
                        component: load('views/enroll/index'),
                        meta: {title: '报名', permissionCode: 'enroll'},
                        redirect,
                        children: [{
                            name: 'enroll',
                            path: 'enroll',
                            component: load('views/enroll/list/index'),
                            meta: {title: '报名管理', permissionCode: 'enroll'}
                        },]
                    },

                    // {
                    //     name: 'schoolIndex',
                    //     path: '/schoolIndex',
                    //     component: load('views/school/index1'),
                    //     meta: {title: '学校首页', permissionCode: 'schoolIndex'}
                    // },
                    {
                        name: 'informationManager',
                        path: 'informationManager',
                        component: load('views/information/index'),
                        meta: {title: '活动管理', permissionCode: 'enroll'},
                        redirect,
                        children: [
                            {
                                name: 'information',
                                path: 'information',
                                component: load('views/information/index'),
                                meta: {title: '活动发布', permissionCode: 'information', icon: 'icon-liebiao'},
                                redirect,
                                children: [
                                    {
                                        name: 'informationList',
                                        path: 'informationList',
                                        props: true,
                                        meta: {
                                            title: '资讯列表',
                                            permissionCode: 'information',
                                            hidden: true,
                                            icon: 'icon-biaodan'
                                        },
                                        component: load('views/information/list')
                                    },
                                    {
                                        name: 'informationPage',
                                        path: 'page/:routeParams?',
                                        props: true,
                                        meta: {
                                            title: '资讯详情',
                                            permissionCode: 'information',
                                            hidden: true,
                                            icon: 'icon-biaodan'
                                        },
                                        component: load('views/information/page')
                                    }
                                ]
                            },
                            {
                                name: 'filenotify',
                                path: 'filenotify',
                                component: load('views/filenotify/index'),
                                meta: {title: '文件通知', permissionCode: 'filenotify', icon: 'icon-liebiao'},
                                redirect,
                                children: [
                                    {
                                        name: 'filenotifyList',
                                        path: 'filenotifyList',
                                        props: true,
                                        meta: {
                                            title: '通知列表',
                                            permissionCode: 'filenotify',
                                            hidden: true,
                                            icon: 'icon-biaodan'
                                        },
                                        component: load('views/filenotify/list')
                                    },
                                    {
                                        name: 'filenotifyPage',
                                        path: 'page/:routeParams?',
                                        props: true,
                                        meta: {
                                            title: '资讯详情',
                                            permissionCode: 'filenotify',
                                            hidden: true,
                                            icon: 'icon-biaodan'
                                        },
                                        component: load('views/filenotify/page')
                                    }
                                ]
                            },
                            {
                                name: 'jsgz',
                                path: 'rules',
                                component: load('views/rules/index'),
                                meta: {title: '竞赛规则', permissionCode: 'jsgz', icon: 'icon-liebiao'},
                                redirect,
                                children: [
                                    {
                                        name: 'rulesList',
                                        path: 'rulesList',
                                        props: true,
                                        meta: {
                                            title: '规则列表',
                                            permissionCode: 'jsgz',
                                            hidden: true,
                                            icon: 'icon-biaodan'
                                        },
                                        component: load('views/rules/list')
                                    },
                                    {
                                        name: 'rulesPage',
                                        path: 'page/:routeParams?',
                                        props: true,
                                        meta: {
                                            title: '规则详情',
                                            permissionCode: 'jsgz',
                                            hidden: true,
                                            icon: 'icon-biaodan'
                                        },
                                        component: load('views/rules/page')
                                    }
                                ]
                            },
                            {
                                name: 'indexMessage',
                                path: 'indexMessage',
                                component: load('views/indexMessage/index'),
                                meta: {title: '通知公告', permissionCode: 'indexMessage'}
                            },

                            {
                                name: 'indexKeXue',
                                path: 'indexKeXue',
                                component: load('views/indexKeXue/index'),
                                meta: {title: '青少年科普报告', permissionCode: 'indexKeXue'}
                            },

                            {
                                name: 'youXiuAnLi',
                                path: 'youXiuAnLi',
                                component: load('views/youXiuAnLi/index'),
                                meta: {title: '优秀案例', permissionCode: 'youXiuAnLi'}
                            },
                            {
                                name: 'xiaoNeiShisKeCheng',
                                path: 'xiaoNeiShisKeCheng',
                                component: load('views/xiaoNeiShisKeCheng/index'),
                                meta: {title: '校内实施课程', permissionCode: 'xiaoNeiShisKeCheng'}
                            },
                            {
                                name: 'kaiFangKeCheng',
                                path: 'kaiFangKeCheng',
                                component: load('views/kaiFangKeCheng/index'),
                                meta: {title: '开放学习课程', permissionCode: 'kaiFangKeCheng'}
                            },
                            {
                                name: 'saiShiHuoDong',
                                path: 'saiShiHuoDong',
                                component: load('views/saiShiHuoDong/index'),
                                meta: {title: '活动及赛事推荐', permissionCode: 'saiShiHuoDong'}
                            },
                            {
                                name: 'youXiuAnLiExamine',
                                path: 'youXiuAnLiExamine',
                                component: load('views/youXiuAnLiExamine/index'),
                                meta: {title: '优秀案例审核', permissionCode: 'youXiuAnLiExamine'}
                            },
                            ,]
                    },


                    {
                        name: 'teacher',
                        path: 'teacher',
                        component: load('views/teacher/moduleIndex'),
                        meta: {title: '教师管理', permissionCode: 'teacher'},
                        redirect,
                        children: [{
                            name: 'teacherList',
                            path: 'teacherList',
                            component: load('views/teacher/index'),
                            meta: {title: '教师管理', permissionCode: 'teacherList'},
                        },{
                            name: 'classSituation',
                            path: 'classSituation',
                            meta: {title: '排课总览', permissionCode: 'classSituation'},
                            component: load('views/teacher/classSituation')
                        }]
                    },

                    {
                        name: 'room',
                        path: 'room',
                        component: load('views/room/index'),
                        meta: {title: '教室管理', permissionCode: 'room'},
                        redirect,
                        children: [{
                            name: 'roomList',
                            path: 'roomList',
                            component: load('views/room/index'),
                            meta: {title: '教室管理', permissionCode: 'roomList'}
                        },]
                    },
                    {
                        name: 'subjects',
                        path: 'subjects',
                        component: load('views/subject/moduleIndex'),
                        meta: {title: '课程管理', permissionCode: 'subjects'},
                        redirect,
                        children: [{
                            name: 'lessonManager',
                            path: 'lessonManager',
                            component: load('views/lesson/index'),
                            meta: {title: '课程管理(管理员)', permissionCode: 'lessonManager'}
                        },
                            {
                                name: 'lessonManagerSchool',
                                path: 'lessonManagerSchool',
                                component: load('views/lessonSchool/index'),
                                meta: {title: '课程管理(管理员)', permissionCode: 'lessonManagerSchool'}
                            },
                            {
                                name: 'kepu',
                                path: 'kepu',
                                component: load('views/kepu/index'),
                                meta: {title: '科普资源', permissionCode: 'kepu'}
                            },
                            {
                                name: 'lessonResource',
                                path: 'lessonResource',
                                props: true,
                                component: load('views/lessonResource/index'),
                                meta: {
                                    title: '课程资源管理', props: true, permissionCode: 'lessonResource', hidden: true,
                                },
                            }
                            , {
                                name: 'subjectManager',
                                path: 'subjectManager',
                                component: load('views/subject/index'),
                                meta: {title: '学科管理', permissionCode: 'subjectManager'}
                            },]
                    },
                    {
                        name: 'classManager',
                        path: 'classManager',
                        component: load('views/Clazz/moduleIndex'),
                        meta: {title: '班级管理', permissionCode: 'classManager'},
                        redirect,
                        children: [{
                            name: 'classList',
                            path: 'classList',
                            component: load('views/Clazz/index'),
                            meta: {title: '班级管理', permissionCode: 'classList'}
                        },
                            {
                                name: 'kebiaozonglan',
                                path: 'kebiaozonglan',
                                meta: {title: '排课总览', permissionCode: 'kebiaozonglan'},
                                component: load('views/system/week/total')
                            }]
                    },
                    {
                        name: 'student',
                        path: 'student',
                        component: load('views/student/moduleIndex'),
                        meta: {title: 'student', permissionCode: 'student'},
                        redirect,
                        children: [{
                            name: 'studentList',
                            path: 'studentList',
                            component: load('views/student/index'),
                            meta: {title: '学生列表', permissionCode: 'studentList'}
                        },
                            //     {
                            //     name: 'changeClasses',
                            //     path: 'changeClasses',
                            //     component: load('views/changeClass/index'),
                            //     meta: {title: '更换班级', permissionCode: 'changeClasses'}
                            // },
                        ]
                    },

                    {
                        name: 'order',
                        path: 'order',
                        component: load('views/order/index'),
                        meta: {title: '订单管理', permissionCode: 'order'}
                    },


                    {
                        name: 'order',
                        path: 'order',
                        component: load('views/order/index'),
                        meta: {title: '订单管理', permissionCode: 'order', icon: 'icon-liebiao'},
                        redirect,
                        children: [
                            {
                                name: 'order',
                                path: 'order',
                                component: load('views/order/tabs'),
                                meta: {title: '订单管理', permissionCode: 'order'}
                            },
                        ]
                    },

                    {
                        name: 'system',
                        path: 'system',
                        component: load('views/system/index'),
                        meta: {title: '系统管理', permissionCode: 'finance'},
                        redirect,
                        children: [
                            {
                                name: 'myMessage',
                                path: 'myMessage',
                                component: load('views/system/myMessage/index'),
                                meta: {title: '我的消息', permissionCode: 'myMessage'},
                                redirect,
                                children: [
                                    {
                                        name: 'myMessageList',
                                        path: 'myMessageList',
                                        props: true,
                                        meta: {
                                            title: '信息列表',
                                            permissionCode: 'myMessage',
                                            hidden: true,
                                            icon: 'icon-biaodan'
                                        },
                                        component: load('views/system/myMessage/list')
                                    },
                                    {
                                        name: 'myMessageEdit',
                                        path: 'page/:routeParams?',
                                        props: true,
                                        meta: {
                                            title: '信息详情',
                                            permissionCode: 'myMessage',
                                            hidden: true,
                                            icon: 'icon-biaodan'
                                        },
                                        component: load('views/system/myMessage/messageEdit')
                                    }
                                ]
                            },
                            {
                                name: 'message',
                                path: 'message',
                                component: load('views/system/message/index'),
                                meta: {title: '站内信管理', permissionCode: 'message', icon: 'icon-liebiao'},
                                redirect,
                                children: [
                                    {
                                        name: 'messageList',
                                        path: 'messageList',
                                        props: true,
                                        meta: {
                                            title: '信息列表',
                                            permissionCode: 'message',
                                            hidden: true,
                                            icon: 'icon-biaodan'
                                        },
                                        component: load('views/system/message/list')
                                    },
                                    {
                                        name: 'messageEdit',
                                        path: 'page/:routeParams?',
                                        props: true,
                                        meta: {
                                            title: '信息详情',
                                            permissionCode: 'message',
                                            hidden: true,
                                            icon: 'icon-biaodan'
                                        },
                                        component: load('views/system/message/messageEdit')
                                    }
                                ]
                            },
                            {
                                name: 'school',
                                path: 'school',
                                component: load('views/aschool/index'),
                                meta: {title: '学校管理', permissionCode: 'school'}
                            },
                            {
                                name: 'errorSchool',
                                path: 'errorSchool',
                                component: load('views/errorSchool/index'),
                                meta: {title: '错误地址学校管理', permissionCode: 'errorSchool'}
                            },

                            {
                                name: 'baseList',
                                path: 'baseList',
                                component: load('views/baseList/index'),
                                meta: {title: '数据列表', permissionCode: 'baseList'}
                            },

                            {
                                name: 'partBaseList',
                                path: 'partBaseList',
                                component: load('views/partBaseList/index'),
                                meta: {title: '部分数据列表', permissionCode: 'partBaseList'}
                            },


                            {
                                name: 'moneyList',
                                path: 'moneyList',
                                component: load('views/moneyList/index'),
                                meta: {title: '财务数据', permissionCode: 'moneyList'}
                            },
                            {
                                name: 'errorXdSchool',
                                path: 'errorXdSchool',
                                component: load('views/errorXdSchool/index'),
                                meta: {title: '错误学段学校管理', permissionCode: 'errorXdSchool'}
                            },
                            {
                                name: 'organization',
                                path: 'organization',
                                component: load('views/system/organization/index'),
                                meta: {title: '组织机构', permissionCode: 'organization'}
                            },
                            {
                                name: 'skuaccount',
                                path: 'skuaccount',
                                component: load('views/system/skuaccount/index'),
                                meta: {title: '学校管理员', permissionCode: 'skuaccount'}
                            },
                            {
                                name: 'account',
                                path: 'account',
                                component: load('views/system/account/index'),
                                meta: {title: '账户管理', permissionCode: 'account'}
                            },
                            {
                                name: 'role',
                                path: 'role',
                                component: load('views/system/role/index'),
                                meta: {title: '角色管理', permissionCode: 'role'}
                            },
                            {
                                name: 'dict',
                                path: 'dict',
                                component: load('views/system/dict/index'),
                                meta: {title: '字典管理', permissionCode: 'dict'}
                            },
                            {
                                name: 'wkcategory',
                                path: 'wkcategory',
                                component: load('views/system/wkcategory/index'),
                                meta: {title: '微课分类', permissionCode: 'wkcategory'}
                            },
                            {
                                name: 'point',
                                path: 'point',
                                component: load('views/point/index'),
                                meta: {title: '积分列表', permissionCode: 'point'}
                            },
                            {
                                name: 'log',
                                path: 'log',
                                component: load('views/system/log/index'),
                                meta: {title: '操作日志', permissionCode: 'log'}
                            },
                            {
                                name: 'menu',
                                path: 'menu',
                                meta: {title: '菜单管理', permissionCode: 'menu'},
                                component: load('views/system/resource/index')
                            },
                            {
                                name: 'zhoukebiao',
                                path: 'zhoukebiao',
                                meta: {title: '周课表', permissionCode: 'zhoukebiao'},
                                component: load('views/system/week/index')
                            },
                            ,
                            {
                                name: 'banner',
                                path: 'banner',
                                component: load('views/banner/index'),
                                meta: {title: '轮播图管理', permissionCode: 'banner'}
                            },
                            {
                                name: 'openCourse',
                                path: 'openCourse',
                                component: load('views/system/openCourse/index'),
                                meta: {title: '开课字段设置', permissionCode: 'openCourse'},
                            },
                            // {
                            //     name: 'upgrate',
                            //     path: 'upgrate',
                            //     component: load('views/system/upgrade/index'),
                            //     meta: {title: '一键升级', permissionCode: 'upgrate'}
                            // },
                            {
                                name: 'declare',
                                path: 'declare',
                                component: load('views/system/declare/index'),
                                meta: {title: '我的申报', permissionCode: 'declare'},
                            },
                            {
                                name: 'declareManage',
                                path: 'declareManage',
                                component: load('views/system/declareManage/index'),
                                meta: {title: '申报管理', permissionCode: 'declareManage'},
                            },

                            {
                                name: 'oldDeclareManage',
                                path: 'oldDeclareManage',
                                component: load('views/system/oldDeclareManage/index'),
                                meta: {title: '旧申报管理', permissionCode: 'oldDeclareManage'},
                            },
                            {
                                name: 'wkManage',
                                path: 'wkManage',
                                component: load('views/system/wkManage/index'),
                                meta: {title: '微课管理', permissionCode: 'wkManage'},
                            },

                            {
                                name: 'courseAccount',
                                path: 'courseAccount',
                                component: load('views/courseAccount/index'),
                                meta: {title: '精品课账号管理', permissionCode: 'courseAccount'},
                            },
                            {
                                name: 'commentManage',
                                path: 'commentManage',
                                component: load('views/commentManage/index'),
                                meta: {title: '评论管理', permissionCode: 'commentManage'},
                            },
                            {
                                name: 'log',
                                path: 'log',
                                component: load('views/system/log/index'),
                                meta: {title: '操作日志', permissionCode: 'log'}
                            },
                            {
                                name: 'schoolView',
                                path: 'schoolView',
                                component: load('views/system/schoolView/index'),
                                meta: {title: '学校首页', permissionCode: 'schoolView'}
                            },
                            // {
                            //     name: 'engineering',
                            //     path: 'engineering',
                            //     component: load('views/system/engineering/index'),
                            //     meta: {title: '用户管理工程', permissionCode: 'engineering'}
                            // },
                            {
                                name: 'schoolYear',
                                path: 'schoolYear',
                                component: load('views/system/schoolYear/index'),
                                meta: {title: '学年管理', permissionCode: 'schoolYear'}
                            },
                            // {
                            //     name: 'comment',
                            //     path: 'comment',
                            //     component: load('views/system/comment/index'),
                            //     meta: {title: '评论管理', permissionCode: 'comment'}
                            // },
                        ]
                    }
                ]
            }
        ]
    }
}



// WEBPACK FOOTER //
// ./src/configure/router/routerTable.js